<template>
  <div>
    <Loading :isActive="loading" />
    <CTabs variant="tabs" class="nav-tabs-boxed">
      <CTab
        title="Avançado"
        v-if="
          loadAuthorizationAction(
            'ADMIN_CONFIGURACAO',
            'CONFIGURACOES_AVANCADO'
          )
        "
      >
        <h2>As configurações aqui existentes foram mescladas com a aba de parâmetros</h2>
        <router-link to="/configuracoes/parametros">Clique aqui para acessar</router-link>
      </CTab>
      <CTab
        title="Integrações"
        v-if="
          loadAuthorizationAction(
            'ADMIN_CONFIGURACAO',
            'CONFIGURACOES_INTEGRACOES'
          )
        "
      >
        <h2>As configurações aqui existentes foram movidas para o módulo de Integrações</h2>
        <router-link v-if="podeAcessarIntegracoes" to="/integracoes">Clique aqui para acessar</router-link>
        <p v-else>Peça acesso ao módulo de Integrações ao administrador do sistema.</p>
      </CTab>
      <CTab
        title="Traduções"
        v-if="
          loadAuthorizationAction(
            'ADMIN_CONFIGURACAO',
            'CONFIGURACOES_TRADUCOES'
          )
        "
      >
        <Traducoes />
      </CTab>
      <CTab
        title="Temas"
        v-if="
          loadAuthorizationAction('ADMIN_CONFIGURACAO', 'CONFIGURACOES_TEMAS')
        "
      >
        <Temas :temas="temas" :salvarTema="salvarTema"></Temas>
      </CTab>
      <CTab
        title="Força de Vendas"
        v-if="
          temSistemaFV &&
          loadAuthorizationAction(
            'ADMIN_CONFIGURACAO',
            'CONFIGURACOES_FORCA_VENDAS'
          )
        "
      >
        <ForcaVendas />
      </CTab>
    </CTabs>
  </div>
</template>
<script>
import { upload, get, put } from "@/helpers/apiRequest";
import { loadAuthorizationAction, moduloAutorizado } from "@/helpers/cargas";
import config from "@/config";
import Traducoes from "./Traducoes";
import Temas from "./Temas";
import ForcaVendas from "./ForcaVendas";
import _find from "lodash/find";
import Toast from "vue-toastification";
import Vue from "vue";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
Vue.use(Toast, {});
const TERMO_STATUS_INICIAL = {
  geral: {
    msg: null,
    error: null,
  },
  edit: {
    msg: null,
    error: null,
  },
};

export default {
  name: "configuracoes",
  components: {
    ForcaVendas,
    Traducoes,
    Temas,
    Toast,
  },
  props: ["sistemas"],
  computed: {
    // A aba aparece por CONFIGURACOES_INTEGRACOES, mas o destino é guardado por
    // ADMIN_INTEGRACAO. A migration que criou o módulo alinhou os dois na
    // atualização; depois dela, a ação antiga continua marcável no cadastro de
    // perfil, e quem a receber sozinho veria um link que responde 403.
    podeAcessarIntegracoes() {
      return moduloAutorizado("ADMIN_INTEGRACAO");
    },

    temSistemaB2B() {
      return !!_find(this.sistemas, (sistema) => sistema.chave === "B2B");
    },

    temSistemaFV() {
      return !!_find(
        this.sistemas,
        (sistema) => sistema.chave === "FORCA_VENDAS"
      );
    },
  },
  data() {
    return {
      descPlural: "",
      descSingular: "",
      loading: false,
      temas: [],
      traducoes: [],
      termosData: [],
      termoStatus: TERMO_STATUS_INICIAL,
      images: {
        logo: config.api + "/images/logo?cache=" + this.makeHash(),
        favicon: config.api + "/images/favicon/icon-72x72",
        background: config.api + "/images/background/",
      },
      uploadedImages: {
        logo: config.api + "/images/logo",
        favicon: config.api + "/images/favicon/icon-72x72",
        background: config.api + "/images/background/",
      },
      urls: {
        logo: config.api + "/admin/logo",
        favicon: config.api + "/admin/favicon",
        background: config.api + "/admin/background",
      },
    };
  },
  methods: {
    loadDescricaoModulo() {
      const { modulos } = JSON.parse(localStorage.getItem("app"));
      const { descPlural, descSingular } = modulos.find(
        (m) => m.nome === "ADMIN_CONFIGURACAO"
      );
      this.descPlural = descPlural;
      this.descSingular = descSingular;
    },
    loadAuthorizationAction,
    makeHash() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (let i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      return text;
    },
    handleUpload(type, extraInputs) {
      event.preventDefault();

      const self = this;

      this.loading = true;

      return upload(
        this.urls[type],
        "image",
        event.target.files[0],
        extraInputs
      )
        .then((response) => {
          this.loading = false;

          if (type !== "background") {
            self.images[type] = self.uploadedImages[type] +=
              "?cache=" + self.makeHash();
          }
        })
        .catch((error) => {
          this.loading = false;
          alert(error.message);
        });
    },
    loadTemas() {
      this.loading = true;
      get("/admin/temas")
        .then((json) => (this.temas = json))
        .finally(() => (this.loading = false));
    },
    salvarTema(tema) {
      this.loading = true;

      const request = put(`/admin/temas/${tema.sistema}`, tema.schema);

      request
        .then(() => this.loadTemas())
        .catch((err) => console.log(err))
        .finally(() => (this.loading = false));

      return request;
    },
  },
  beforeMount() {
    this.loadDescricaoModulo();
    this.loadTemas();
  },
};
</script>
